<template lang="pug">
.ticket-success
  .row
    .section-wrap.success-msg.col-md-6.col-xs-12
      .title 報名成功
      .content.border-styled
        span
          | 您的報名資訊已成功送出，我們將在 2017/10/31 前審核您的報名資料審核後資訊無誤將會通知您付款資訊。
          | 您可以至「
        router-link.link-red(:to="{name: 'user'}") 查看票卷
        span
          | 」取得您的報名進度與付款資訊。
  .row
    .section-wrap.info-schedule.col-md-6.col-xs-12
      .title 訂單資訊
      .content.border-styled
        img.icon(src="~assets/submit-success-icon.png")
        span(v-if="getUser.registered.me") {{ getUser.registered.me.status_string }}
        div(v-if="getUser.registered.me && getUser.registered.me.status !== 1 && getUser.registered.me.status !== 5")
          hr(v-if="getUser.payment.payments_code")
          ul.payment-code(v-if="getUser.payment.payments_code")
            li 繳費代碼
            li {{ getUser.payment.payments_code }}
          hr
          ul.payment-detail
            li
              span 商品名稱
              span {{ getUser.payment.description }}
            li
              span 訂單編號
              span {{ getUser.payment.order_id }}
            li
              span 金額
              span {{ getUser.payment.amount }}
            li(v-if="getUser.payment.expired_at")
              span 繳費期限
              span {{ getUser.payment.expired_at }}
  .row
    .section-wrap.col-md-12
      .title 報名資訊
      .row
        //- .col-md-4(v-if="getUser.registered.me")
          .apply-info.isMe(:class="{'isLeader': getUser.registered.me.is_leader === true}")
            .content.border-styled.ltr-block
              .row
                ul.title.col-md-5
                  li 暱稱
                  li 帳號
                  li 身分證末四碼
                  li Email
                ul.text.col-md-7
                  li {{ getUser.registered.me.nickname }}
                  li {{ getUser.registered.me.gamers_account }}
                  li {{ getUser.registered.me.id_number }}
                  li {{ getUser.registered.me.email }}
        .col-md-4(v-if="getUser.registered.group", v-for="register in getUser.registered.group")
          .apply-info(:class="{'isLeader': register.is_leader === true, 'isMe': register.is_me}")
            .content.border-styled.ltr-block
              .row
                ul.title.col-md-5
                  li 暱稱
                  li 帳號
                  li 身分證末四碼
                  li Email
                ul.text.col-md-7
                  li {{ register.nickname }}
                  li {{ register.gamers_account }}
                  li {{ register.id_number }}
                  li {{ register.email }}
  hr
  .btn-wrap
    .btn.ghost-btn.next-btn(@click="$router.push({name: 'homepage'})") 回首頁
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'ticketSuccess',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchRegistered().then((res) => {
        console.log('status: ', res.me.status)
        if (res.me.status !== 1 && res.me.status !== 5) {
          vm.fetchPayment()
        }
      }, (err) => {
        vm.$swal({
          title: '查無訂單',
          text: '是不是還沒購票呢？請先前往購票' + '\n' + err.type,
          type: 'error',
          // showCancelButton: true,
          confirmButtonText: '關閉'
        }).then((res) => {
          vm.$router.push({name: 'ticketType'})
        })
      })
    })
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'getUser'
    ])
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'fetchRegistered',
      'fetchPayment'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
@import '~stylesheets/components'
.border-styled
  border: 1px solid $grey
  padding: 16px
  +border-radius(2px)
.section-wrap
  font-size: 16px
  margin-bottom: 24px
  &:first-child
    margin-top: 36px
  &.success-msg
    line-height: 160%
  &.info-schedule
    .icon
      margin-right: 16px
  .title
    font-weight: bold
    font-size: 18px
    margin-bottom: 16px
  .content
    color: $grey
  .payment-code
    padding: 0 8px
    list-style: none
    font-size: 20px
    li
      &:first-child
        font-size: 14px
        color: $grey
      &:last-child
        color: #fff
        font-weight: bold
        letter-spacing: 2px
  .payment-detail
    list-style: none
    padding: 0 8px
    display: table
    position: relative
    width: 100%
    li
      display: table-row
      span
        display: table-cell
        border-bottom: 1px solid $grey-dark
        color: #fff
        &:first-child
          color: $grey
          text-align
          font-size: 14px
      &:not(:first-child)
        span
          padding-top: 6px
      &:not(:last-child)
        span
          padding-bottom: 6px
      &:last-child
        span
          border-bottom: none
  .apply-info
    margin: 20px 0
    overflow: hidden
    position: relative
    .content.ltr-block
      @extend %clearfix
      ul
        list-style: none
        padding: 0
        margin: 0
        font-size: 15px
        &.title
          float: left
          color: #fff
          padding-left: 16px
        &.text
          float: left
          padding-left: 16px
          max-width: 100%
          overflow: hidden
        li
          line-height: 180%
    &.isLeader
      .border-styled
        border: 1px solid #fff
      &:before
        content: '隊長'
        background-color: #FFF
        color: $black
        font-size: 13px
        padding: 3px 10px
        position: absolute
        right: 0
        top: 0
    &.isMe
      .border-styled
        border: 1px solid $green
      .content
        ul
          &.title
            color: $green
      &:after
        content: '我'
        background-color: $green
        color: $black
        font-size: 13px
        padding: 3px 10px
        position: absolute
        right: 0
        top: 0
    &.isMe.isLeader
      .border-styled
        border: 1px solid $green
      .content
        ul
          &.title
            color: $green
      &:after
        content: '我, 隊長'
        background-color: $green
        color: $black
        font-size: 13px
        padding: 3px 10px
        position: absolute
        right: 0
        top: 0
</style>



// WEBPACK FOOTER //
// ticketSuccess.vue?4dd42334